import {
  Button,
  datesToISO,
  ErrorMessage,
  Input,
  modalHandler,
  success,
  useCustomForm,
  useUpdateVerificationStagesSmsSendingDateMutation,
} from "@";
import type { UpdateVerificationStagesSmsSendingDateRequest } from "@/shared/hooks/queries/useUpdateVerificationStagesSmsSendingDate.ts";
import {
  updateSmsSendingDateDefaultValues,
  updateSmsSendingDateSchema,
} from "../lib/validation.ts";
import { searchHandler } from "../lib/helpers.ts";
import type {
  UpdateSmsSendingDateFormValues,
  VerifySearchValues,
} from "../types.ts";

interface UpdateSmsSendingDateModalProps {
  ids: number[];
  selectingAll: boolean;
  searchValues: VerifySearchValues;
  onSuccess: () => void;
}

const MODAL_ID = "update-sms-sending-date-modal";

const UpdateSmsSendingDateModal = ({
  ids,
  selectingAll,
  searchValues,
  onSuccess,
}: UpdateSmsSendingDateModalProps) => {
  const { watch, errors, reset, setValue, register, handleSubmit } =
    useCustomForm(
      updateSmsSendingDateDefaultValues,
      updateSmsSendingDateSchema,
    );

  const mutation = useUpdateVerificationStagesSmsSendingDateMutation();

  const submit = async (form: UpdateSmsSendingDateFormValues) => {
    const payload: UpdateVerificationStagesSmsSendingDateRequest = {
      verificationStagesIds: selectingAll ? [] : ids,
      dateToSendSmsNotification: datesToISO(form.dateToSendSmsNotification),
    };

    if (selectingAll) {
      payload.searchVerificationsRequestViewModel = searchHandler(searchValues);
    }

    await mutation.mutateAsync(payload);
    success("تم تحديث تاريخ التنفيذ بنجاح");
    reset();
    modalHandler(MODAL_ID);
    onSuccess();
  };

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  return (
    <form onSubmit={handleSubmit(submit)} className="p-2 md:p-5">
      {ids?.length === 0 && (
        <ErrorMessage className="mb-5" value="رجاء تحديد طلب واحد على الاقل" />
      )}

      <Input
        type="datepicker"
        label="تاريخ التنفيذ"
        showTimeSelect
        minDate={today}
        styles="h-14 input"
        value={watch("dateToSendSmsNotification")}
        input={register("dateToSendSmsNotification")}
        error={errors.dateToSendSmsNotification}
        change={(e: Date | null) => setValue("dateToSendSmsNotification", e)}
        disabled={ids?.length === 0}
      />

      {ids?.length > 0 && (
        <Button
          type="submit"
          className="mt-5 w-full py-3"
          title="تحديث التاريخ"
          isLoading={mutation.isPending}
        />
      )}
    </form>
  );
};

export default UpdateSmsSendingDateModal;
export { MODAL_ID as UPDATE_SMS_SENDING_DATE_MODAL_ID };
